export default __webpack_public_path__ + "static/media/sportsKendra.cd53dac1.png";